/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import {
  LocationsSection,
  LocationsFilterWrapperV2,
  LocationsParticipating,
} from 'views/rebranded-module/location-module/LocationsViewV2/components';
import { FILTER_TYPE } from 'views/rebranded-module/location-module/LocationsViewV2/utils/constants';
import { useSelector } from 'react-redux';
import { ImgBox } from 'views/rebranded-module/common/components';
import StyledBox from 'views/rebranded-module/location-module/LocationsViewV2/components/LocationsWrapperV2/LocationsWrapperV2.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const LocationsWrapperV2 = (props) => {
  const {
    usCountry,
    usLocations,
    nonUsLocations,
    setMapCenter,
    defaultVehicleType,
    getLocationsData,
  } = props;
  const content = useContent();
  const appNavigator = useAppNavigator();
  const showMembership = useSelector(
    (state) => state.globalData.showMembership,
  );

  const [filteredLocations, setFilteredLocations] = useState({
    usLocations,
    nonUsLocations,
  });
  const [filter, setFilter] = useState(
    appNavigator.query.club_locations_segment === undefined
      ? FILTER_TYPE.ALL_LOCATIONS
      : FILTER_TYPE.CLUB,
  );
  const [searchQuery, setSearchQuery] = useState('');

  const filterLocations = (query, locations) => {
    if (!query) return locations;

    const filteredResult = [];
    const match = new RegExp(query.trim(), 'i');
    locations.forEach((location) => {
      const copiedLocation = { ...location };
      const result = match.test(copiedLocation.region.name);
      if (!result) {
        if (copiedLocation.markets) {
          const filteredMarkets = [];
          copiedLocation.markets.forEach((market) => {
            const copiedMarket = { ...market };
            const marketResult = match.test(market.name);

            if (marketResult) {
              filteredMarkets.push(copiedMarket);
            } else {
              copiedMarket.locations = copiedMarket.locations.filter(
                (marketLocation) => match.test(marketLocation.name),
              );
              if (copiedMarket.locations.length > 0) {
                filteredMarkets.push(copiedMarket);
              }
            }
          });

          if (filteredMarkets.length > 0) {
            copiedLocation.markets = filteredMarkets;
            filteredResult.push(copiedLocation);
          }
        } else {
          const copiedLocs = copiedLocation.locations.filter((loc) => match.test(loc.display_name));

          if (copiedLocs?.locations?.length > 0) {
            filteredResult.push(copiedLocation);
          }
        }
      } else {
        filteredResult.push(copiedLocation);
      }
    });

    return filteredResult.sort((a, b) => a.region.name.localeCompare(b.region.name));
  };

  const handleFilterLocations = (query) => {
    const filteredUsLocations = filterLocations(query, usLocations);
    const filteredNonUsLocations = filterLocations(query, nonUsLocations);

    setFilteredLocations((prev) => ({
      nonUsLocations: filteredNonUsLocations,
      usLocations: filteredUsLocations,
    }));
  };

  const handleSearchQueryChange = (e) => {
    setSearchQuery(e.target.value);
    handleFilterLocations(e.target.value);
  };
  useEffect(() => {
    setFilteredLocations({
      nonUsLocations,
      usLocations,
    });
  }, [usLocations, nonUsLocations]);
  return (
    <StyledBox pt={3}>
      <Box className="LRContent">
        <LocationsFilterWrapperV2
          searchQuery={searchQuery}
          setMapCenter={setMapCenter}
          filter={filter}
          setFilter={setFilter}
          handleSearchQueryChange={handleSearchQueryChange}
          getLocationsData={getLocationsData}
          content={content}
        />

        {showMembership && (
          <LocationsParticipating content={content.LocationsPage} />
        )}
        <LocationsSection
          usCountry={usCountry}
          filteredUsLocations={filteredLocations.usLocations}
          filteredNonUsLocations={filteredLocations.nonUsLocations}
          filter={filter}
          expandAccordion={!!searchQuery || undefined}
          defaultVehicleType={defaultVehicleType}
          content={content.LocationsPage}
        />
      </Box>
      <Box className="LRBackground">
        <ImgBox
          image={{
            src: '/imgs/Rebranding/locations/locations-bg.jpg',
            alt: 'background',
          }}
          width="100%"
          height="100%"
        />
        <Box className="LRBGOverlay" />
      </Box>
    </StyledBox>
  );
};

export { LocationsWrapperV2 };
